import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Flex,
  Textarea,
} from '@chakra-ui/react';

// datetime-local "YYYY-MM-DDTHH:mm" bekler ve LOKAL saat olarak yorumlar;
// toISOString() ile kısaltmak değeri UTC'ye kaydırır.
const toDateTimeLocalValue = value => {
  if (!value) return '';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const pad = number => String(number).padStart(2, '0');

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
    date.getDate()
  )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

const ServiceSummaryEditModal = ({
  isOpen,
  onClose,
  serviceSummary,
  onSave,
}) => {
  const [formData, setFormData] = useState({
    date: '',
    company: '',
    provider: '',
    authorized: '',
    proof: null,
  });
  const [isDateInvalid, setIsDateInvalid] = useState(false);

  useEffect(() => {
    if (serviceSummary) {
      setFormData({
        // GET tarihi "lastService" ile döndürüyor, PUT ise "date" bekliyor.
        date: toDateTimeLocalValue(
          serviceSummary.date || serviceSummary.lastService
        ),
        company: serviceSummary.company || '',
        provider: serviceSummary.provider || '',
        authorized: serviceSummary.authorized || '',
        proof: serviceSummary.proof || null,
      });
      setIsDateInvalid(false);
    }
  }, [serviceSummary]);

  const handleChange = e => {
    const { name, value } = e.target;
    if (name === 'date') {
      setIsDateInvalid(false);
    }
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = e => {
    setFormData({ ...formData, proof: e.target.files[0] });
  };

  const handleSubmit = () => {
    const parsedDate = formData.date ? new Date(formData.date) : null;

    if (!parsedDate || Number.isNaN(parsedDate.getTime())) {
      setIsDateInvalid(true);
      return;
    }

    const formDataToSend = new FormData();
    const formattedDate = parsedDate.toISOString();

    formDataToSend.append('date', formattedDate);
    formDataToSend.append('company', formData.company);
    formDataToSend.append('provider', formData.provider);
    formDataToSend.append('authorized', formData.authorized);

    if (formData.proof) {
      formDataToSend.append('proof', formData.proof);
    }

    onSave(formDataToSend);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Service Summary</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex direction="column" gap={4}>
            <FormControl id="date" isInvalid={isDateInvalid}>
              <Flex alignItems="center">
                <FormLabel mb={0} width="150px">
                  Date
                </FormLabel>
                <Input
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  placeholder="Date"
                  type="datetime-local"
                  isRequired
                />
              </Flex>
              <FormErrorMessage ml="150px">
                Please select a valid date and time.
              </FormErrorMessage>
            </FormControl>
            <FormControl id="company">
              <Flex alignItems="center">
                <FormLabel mb={0} width="150px">
                  Company
                </FormLabel>
                <Input
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder="Company"
                  isRequired
                />
              </Flex>
            </FormControl>
            <FormControl id="provider">
              <Flex alignItems="center">
                <FormLabel mb={0} width="150px">
                  Provider
                </FormLabel>
                <Input
                  name="provider"
                  value={formData.provider}
                  onChange={handleChange}
                  placeholder="Provider"
                  isRequired
                />
              </Flex>
            </FormControl>
            <FormControl id="authorized">
              <Flex alignItems="center">
                <FormLabel mb={0} width="150px">
                  Authorized
                </FormLabel>
                <Textarea
                  name="authorized"
                  value={formData.authorized}
                  onChange={handleChange}
                  placeholder="Authorized"
                  isRequired
                />
              </Flex>
            </FormControl>
            <FormControl id="proof">
              <Flex alignItems="center">
                <FormLabel mb={0} width="150px">
                  Proof
                </FormLabel>
                <Input
                  type="file"
                  name="proof"
                  onChange={handleFileChange}
                  placeholder="Upload proof"
                  accept=".pdf, .jpeg, .jpg" // Sadece PDF ve JPEG dosyalarını kabul et
                />
              </Flex>
            </FormControl>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={handleSubmit}>
            Save
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ServiceSummaryEditModal;
